var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("static-content-terms" + _vm.cssClass)},[_c('div',{staticClass:"header"},[_c('h1',[_vm._v(_vm._s(_vm.$t('labels.general.terms_of_use')))])]),_vm._v(" "),_c('div',{staticClass:"body"},[(_vm.collection.loading)?_c('spinner'):_vm._e(),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.current.content)}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f0c1c626","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/statics/StaticContentTerms.vue
// module id = null
// module chunks = 